import { type OnChangeFn, type SortingState, getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { useProductInventoryTransactionColumns } from "../../hooks"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { InventoryByTransactionItem, Product } from "@/graphql/codegen/graphql"

interface ProductInventoryTransactionsTableProps {
  product: Product
  data: InventoryByTransactionItem[]
  loading?: boolean
  error?: CombinedError | Error
  sorting: SortingState
  containerRef?: RefObject<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll?: () => void
}

export const ProductInventoryTransactionsTable: FC<ProductInventoryTransactionsTableProps> = ({
  data,
  error,
  loading = false,
  sorting,
  containerRef,
  onSortingChange,
  onScroll,
}) => {
  const columns = useProductInventoryTransactionColumns()

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: loading,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No transaction records found'
    />
  )
}
